import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

const Pencil = styled(Icon).attrs({ name: 'pencil' })`
  align-self: center;
  justify-self: center;
  align-self: center;
`;

const Container = styled.div`
  display: grid;
  cursor: ${({ cursor }) => cursor};

  i {
    opacity: 0.8;
  }

  &:hover i {
    opacity: 1;
  }
`;

export default ({ onClick, isBusy }) => (
  <Container cursor={isBusy ? 'default' : 'pointer'} onClick={onClick} title="Change account">
    {!isBusy && <Pencil />}
  </Container>
);
